module.exports = __webpack_public_path__ + "static/media/tk.5bae5827.svg";